// extracted by mini-css-extract-plugin
export default {"phoneLabel":"phoneInput_phoneLabel__3VuDj","label":"phoneInput_label__63L-y","phoneInput":"phoneInput_phoneInput__Lb8Wv","PhoneNumber":"phoneInput_PhoneNumber__pTxnf"};